const phoneMixin = {
  filters: {
    BrazilianPhone(value) {
      if (!value) return "Não informado";

      return value
        .replace(/[^0-9]/g, "")
        .replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4");
    }
  }
};

export default phoneMixin;
